import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import roc_bla_haz_lev from "../img/sswpIcons/RockBlast/roc_bla_haz_lev.png";

import roc_bla_sit_spe_met from "../img/sswpIcons/RockBlast/roc_bla_sit_spe_met.png";
const json = {
    icon: roc_bla_haz_lev,
    name: "Rock Blasting",
    text: "",
    icons: {
        roc_bla_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: roc_bla_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
